export default "__VITE_ASSET__7628eaba__"